import axios from "axios";

// Add a request interceptor
axios.interceptors.request.use(
  function (config:any) {
    // console.log(config);
    
    config.headers = {
      "Content-Type": "application/json",
      Authorization: config.headers.Authorization,
    };
   
    return config;
  },
  function (error) {
    // Do something with request error

    return Promise.reject(error);
  }
);
export default axios;
